import { defineMessages } from 'react-intl';

export default defineMessages({
    yourInfoTitle: {
        id: 'quoteandbind.ho.views.ho-confirmation.YourInfo',
        defaultMessage: 'Information'
    },
    yourHouseTitle: {
        id: 'quoteandbind.ho.views.ho-confirmation.YourHouse',
        defaultMessage: 'House'
    },
    yourCoveragesTitle: {
        id: 'quoteandbind.ho.views.ho-confirmation.YourCoverages',
        defaultMessage: 'Coverages'
    },
    yourCoveragesLimits: {
        id: 'quoteandbind.ho.views.ho-confirmation.Limits',
        defaultMessage: 'Coverages'
    },
    firstName: {
        id: 'quoteandbind.ho.views.ho-confirmation.FirstName',
        defaultMessage: 'First Name'
    },
    lastName: {
        id: 'quoteandbind.ho.views.ho-confirmation.LastName',
        defaultMessage: 'Last Name'
    },
    emailAddress: {
        id: 'quoteandbind.ho.views.ho-confirmation.Email',
        defaultMessage: 'Email'
    },
    coveragePremiumDetails: {
        id: 'quoteandbind.ho.views.ho-confirmation.Coverage Premium Details',
        defaultMessage: 'Coverage Premium Details'
    },
    baseCoverages: {
        id: 'quoteandbind.ho.views.policy-info.Base Coverages',
        defaultMessage: 'Base Coverages'
    },
    additionalCoverages: {
        id: 'quoteandbind.ho.views.policy-info.Additional Coverages',
        defaultMessage: 'Additional Coverages'
    },

    PolicyIssuanceAccepted : {
        id:'quoteandbind.ho.views.ho-confirmation.Policy Issuance Accepted',
        defaultMessage :'Policy Issuance Accepted'
    },

    confirmationMessage: {
        id: "quoteandbind.views.ho-confirmation.This policy has been approved",
        defaultMessage: "This policy has been approved. Your customer will receive an email confirmation shortly."
    },
    anonymousMessage:{
        id:"quoteandbind.views.confirmation.Your new policy has been issued. Reminder to upload your required documents.",
        defaultMessage: "Your new policy has been issued. Reminder to upload your required documents."
    }
});
